/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback, useMemo, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Collapse,
  Container,
  Fade,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from 'reactstrap';

import classNames from 'classnames';
import { format, parseISO, getYear, getMonth, subYears } from 'date-fns';
// import { ptBR } from 'date-fns/locale';
import * as Yup from 'yup';

import AlertModal from '../../components/AlertModal';
import CustomModal from '../../components/CustomModal';
import DatePickerMaskedInput from '../../components/DatePickerMaskedInput';
// import CustomModalEmitirFatura from '../../components/Financeiro/CustomModalEmitirFatura';
import CustomModalFecharFatura from '../../components/Financeiro/CustomModalFecharFatura';
import CustomModalFecharFaturas from '../../components/Financeiro/CustomModalFecharFaturas';
import CustomModalMotivoCancelamento from '../../components/Financeiro/CustomModalMotivoCancelamento';
import CustomModalPagarFatura from '../../components/Financeiro/CustomModalPagarFatura';
import CustomModalPagarFaturas from '../../components/Financeiro/CustomModalPagarFaturas';
import FinanceiroEdit from '../../components/Financeiro/Edit';
import ModalContaPagarTableInfo from '../../components/ModalFinanceiroTableInfo';
import TableManager from '../../components/TableManager';
import { AppContext } from '../../contexts/app';
import { useManager } from '../../hooks/manager';
import api from '../../services/api';
import { numberToCurrency, objectToFormattedString, objectToFieldValueArrayString } from '../../utils/functions';

const months = [
  { value: 1, label: 'Jan' },
  { value: 2, label: 'Fev' },
  { value: 3, label: 'Mar' },
  { value: 4, label: 'Abr' },
  { value: 5, label: 'Mai' },
  { value: 6, label: 'Jun' },
  { value: 7, label: 'Jul' },
  { value: 8, label: 'Ago' },
  { value: 9, label: 'Set' },
  { value: 10, label: 'Out' },
  { value: 11, label: 'Nov' },
  { value: 12, label: 'Dez' },
];

const COLUMNS_STORAGE_KEY_CONTAS_PAGAR = 'table-manager-contas-pagar-agrupado-columns';
const DEFAULT_HIDDEN_COLUMNS_CONTAS_PAGAR = [
  'nomeTitularConta',
  'nomeBanco',
  'numeroBanco',
  'numeroAgencia',
  'tipoConta',
  'digitoConta',
  'numeroConta',
  'formaPagamento',
  'chavePix',
  'observacoesInternas',
];

function ContasPagarAgrupado() {
  const navigate = useNavigate();
  const alertRef = useRef();
  const modal = useRef();
  const modalFinanceiroEdit = useRef();
  // const modalEmitirFatura = useRef();
  const modalFecharFatura = useRef();
  const modalFecharFaturas = useRef();
  const modalPagarFaturas = useRef();
  const modalPagarFatura = useRef();
  const modalMotivoCancelamento = useRef();
  const modalContaPagarTableInfo = useRef();
  const { setLoading, notificationRef } = useContext(AppContext);
  const {
    load,
    // update,
    // destroy,
    extraData: {
      totalContaPagar = 0,
      totalContaReceber = 0,
    },
  } = useManager();
  const [selectedRows, setSelectedRows] = useState([]);
  const [showCloseFinanceiroModal, setShowCloseFinanceiroModal] = useState(false);
  const [dataCloseFinanceiroInicio, setDataCloseFinanceiroInicio] = useState('');
  const [dataCloseFinanceiroTermino, setDataCloseFinanceiroTermino] = useState('');
  const [validationErrors, setValidationErrors] = useState({});
  const [searchArray, setSearchArray] = useState([]);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [, setUpdateInterval] = useState(null);
  const [showUpdateDetails, setShowUpdateDetails] = useState(false);
  const [selectedColumnsDataFields, setSelectedColumnsDataFields] = useState([]);

  const handleToggleModalContaPagarTableInfo = (row) => {
    console.log('🚀 ~ handleToggleModalContaPagarTableInfo ~ row:', row);
    modalContaPagarTableInfo.current.show({
      query: `/financeiros-contas-pagar?search=${objectToFieldValueArrayString(row._id)}`,
      title: 'Contas a Pagar - Detalhes',
      visibleColumnsDataFields: selectedColumnsDataFields,
    });
  };

  useEffect(() => {
    load('/financeiros-contas-pagar-grouped', 1, []);
  }, [load]);

  // Cleanup do intervalo quando o componente for desmontado
  useEffect(() => () => {
    setUpdateInterval((currentInterval) => {
      if (currentInterval) {
        clearInterval(currentInterval);
      }
      return null;
    });
  }, []);

  const reload = useCallback(() => {
    // console.log('current base url', currentUrl, 'page number', pageNumber);
    setSelectedRows([]);
    load('/financeiros-contas-pagar-grouped', 1, searchArray, 10);
  }, [load, searchArray]);

  const checkUpdateStatus = useCallback(async () => {
    try {
      const response = await api.get('/financeiros-contas-pagar-materialized-view-progress');
      setUpdateStatus(response.data);

      console.log('🚀 ~ checkUpdateStatus ~ response.data.data.isUpdating:', !response.data.data.isUpdating);
      if (!response.data.data.isUpdating) {
        setIsUpdating(false);
        setUpdateInterval((currentInterval) => {
          if (currentInterval) {
            clearInterval(currentInterval);
          }
          return null;
        });
        reload();
      }
    } catch (err) {
      console.error('Erro ao verificar status da atualização:', err);
      setIsUpdating(false);
      setUpdateInterval((currentInterval) => {
        if (currentInterval) {
          clearInterval(currentInterval);
        }
        return null;
      });
    }
  }, []);

  const startFinancialDataUpdate = useCallback(async () => {
    try {
      setLoading({
        loading: true,
        message: 'Iniciando atualização dos dados financeiros...',
      });

      // Inicia a atualização
      await api.get('/financeiros-contas-pagar-materialized-view-full-refresh');

      setLoading(false);
      setShowUpdateModal(true);
      setIsUpdating(true);
      setUpdateStatus(null);

      // Inicia o monitoramento do status
      const interval = setInterval(checkUpdateStatus, 2000); // Verifica a cada 2 segundos
      setUpdateInterval(interval);

      // Primeira verificação imediata
      checkUpdateStatus();

      notificationRef.current.notify({
        message: 'Atualização dos dados financeiros iniciada com sucesso',
        color: 'success',
      });
    } catch (err) {
      setLoading(false);
      console.error('Erro ao iniciar atualização:', err);

      if (err && err.response && err.response.data) {
        const { message } = err.response.data;
        notificationRef.current.notify({
          message: message || 'Falha ao iniciar atualização dos dados financeiros',
          color: 'danger',
        });
      } else {
        notificationRef.current.notify({
          message: 'Falha ao iniciar atualização dos dados financeiros',
          color: 'danger',
        });
      }
    }
  }, [setLoading, checkUpdateStatus, notificationRef]);

  const closeUpdateModal = useCallback(() => {
    setShowUpdateModal(false);
    setUpdateInterval((currentInterval) => {
      if (currentInterval) {
        clearInterval(currentInterval);
      }
      return null;
    });
    setIsUpdating(false);
    setUpdateStatus(null);
  }, []);

  /* const handleCreateCsv = useCallback((_selectedRows = []) => {
    (async () => {
      try {
        setLoading({
          loading: true,
          message: 'Aguarde... Estamos gerando o arquivo CSV... ',
        });

        // await fetch api
        const res = await api.post('/financeiroCSVCreatorReportLists', { financeirosIds: _selectedRows.map(({ _id }) => _id) }, { responseType: 'blob' });
        const fileName = res.headers['content-disposition']
          .replace('attachment; filename=', '')
          .replace('"', '');

        const fileURL = window.URL.createObjectURL(res.data);
        const alink = document.createElement('a');
        alink.href = fileURL;
        alink.target = '_blank';
        alink.rel = 'noopener noreferrer';
        alink.download = fileName;
        alink.click();

        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.error(err);

        if (err && err.response && err.response.data) {
          const { message } = err.response.data;

          if (message) {
            notificationRef.current.notify({
              message,
              color: 'danger',
            });

            return;
          }
        }

        notificationRef.current.notify({
          message: 'Falha ao realizar ao gerar relatório',
          color: 'danger',
        });
      }
    })();
  }, [setLoading]); */

  /* const handleGerarFolhaPagamento = useCallback(() => {
    modalEmitirFatura.current.show({
      selectedRows: selectedRows.filter((selectedRow) => (selectedRow.status === 'fechado')),
    });
  }, [selectedRows]); */

  const handleFecharFaturaSelecionadas = useCallback(() => {
    modalFecharFaturas.current.show({
      selectedRows,
      onReload: reload,
      type: 'conta-pagar',
    });
  }, [selectedRows, reload]);

  const handlePagarFaturaSelecionadas = useCallback(() => {
    modalPagarFaturas.current.show({
      selectedRows,
      onReload: reload,
      type: 'conta-pagar',
    });
  }, [selectedRows, reload]);

  const handleCloseFinanceiro = useCallback(() => {
    (async () => {
      try {
        const validationData = {
          dataCloseFinanceiroInicio,
          dataCloseFinanceiroTermino,
        };

        const schema = Yup.object().shape({
          dataCloseFinanceiroInicio: Yup.string().required('Informe a data de início'),
          dataCloseFinanceiroTermino: Yup.string().required('Informe a data de término'),
        });

        await schema.validate(validationData, {
          abortEarly: false,
        });
        setLoading(true);

        const data = {
          dataInicio: dataCloseFinanceiroInicio,
          dataTermino: dataCloseFinanceiroTermino,
        };

        await api.post('/financeiroPeriodos', data);
        setLoading(false);
        notificationRef.current.notify({
          message: 'Financeiro fechado com sucesso',
        });
      } catch (err) {
        setLoading(false);
        console.log(err);
        setValidationErrors({});
        // Validation failed
        if (err instanceof Yup.ValidationError) {
          notificationRef.current.notify({
            message: 'Por favor, preencha todos os dados necessários para salvar',
            color: 'warning',
          });
          const ve = {};
          err.inner.forEach((e) => {
            ve[e.path] = e.message;
          });
          setValidationErrors(ve);
          return;
        }

        if (err && err.response && err.response.data) {
          const { message } = err.response.data;
          notificationRef.current.notify({
            message,
            color: 'danger',
          });

          return;
        }

        notificationRef.current.notify({
          message: 'Algo inesperado aconteceu e não foi possível salvar',
          color: 'danger',
        });
      }
    })();
  }, [dataCloseFinanceiroInicio, dataCloseFinanceiroTermino]);

  const handleGerarRelatorioContasPagar = useCallback(() => {
    (async () => {
      try {
        setLoading({
          loading: true,
          message: 'Aguarde... Estamos gerando o arquivo CSV... ',
        });

        // await fetch api
        const res = await api.get('/financeiroContaAPagarCSVReport', { responseType: 'blob' });
        const fileName = res.headers['content-disposition']
          .replace('attachment; filename=', '')
          .replace('"', '');

        const fileURL = window.URL.createObjectURL(res.data);
        const alink = document.createElement('a');
        alink.href = fileURL;
        alink.target = '_blank';
        alink.rel = 'noopener noreferrer';
        alink.download = fileName;
        alink.click();

        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.error(err);

        if (err && err.response && err.response.data) {
          const { message } = err.response.data;

          if (message) {
            notificationRef.current.notify({
              message,
              color: 'danger',
            });

            return;
          }
        }

        notificationRef.current.notify({
          message: 'Falha ao gerar relatório de contas a pagar',
          color: 'danger',
        });
      }
    })();
  }, [setLoading, notificationRef]);

  const tipoFormatter = useCallback((row) => {
    if (row?.tipo === 'conta-pagar') {
      return (
        <Badge className="w-100" color="danger" tag="div">
          <i className="fa-solid fa-money-bill-transfer mr-2" />
          a Pagar
        </Badge>
      );
    }

    if (row?.tipo === 'conta-receber') {
      return (
        <Badge className="w-100" color="success" tag="div">
          <i className="fa-solid fa-hand-holding-dollar mr-2" />
          a Receber
        </Badge>
      );
    }

    return (
      <>
        <UncontrolledTooltip target={`tipo-${objectToFormattedString(row._id)}`}>
          Não Identificado
        </UncontrolledTooltip>
        <i
          id={`tipo-${objectToFormattedString(row._id)}`}
          className="fa-solid fa-circle-question text-danger mt-2"
        />
      </>
    );
  }, []);

  /* const formattedCanceladoBy = (row) => {
    const { agendamento: { motivoCancelamento, dataCancelamento, canceladoByCliente }, canceladoByAdmin, canceladoByProfissional } = row;

    if (canceladoByAdmin?.name) {
      return `Motivo do Cancelamento: ${motivoCancelamento || 'Não informado'}. Cancelado pelo Admin ${canceladoByAdmin.name} em ${format(new Date(dataCancelamento), 'dd/MM/yyyy HH:mm', { locale: ptBR })}`;
    }

    if (canceladoByProfissional?.name) {
      return `Motivo do Cancelamento: ${motivoCancelamento || 'Não informado'}. Cancelado pelo Profissional ${canceladoByProfissional.name} em ${format(new Date(dataCancelamento), 'dd/MM/yyyy HH:mm', { locale: ptBR })}`;
    }

    if (canceladoByCliente?.nome) {
      return `Motivo do Cancelamento: ${motivoCancelamento || 'Não informado'}. Cancelado pelo Cliente ${canceladoByCliente.nome} em ${format(new Date(dataCancelamento), 'dd/MM/yyyy HH:mm', { locale: ptBR })}`;
    }

    return 'Não Identificado';
  }; */

  const statusFormatter = useCallback((row) => {
    if (row?.atendimentoStatus === 'cancelado') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          {/* <UncontrolledTooltip target={`agendamento-${objectToFormattedString(row._id)}`}>
            {formattedCanceladoBy(row)}
          </UncontrolledTooltip> */}
          <span id={`agendamento-${objectToFormattedString(row._id)}`}>
            <i className="fa-solid fa-calendar-xmark text-danger mr-2" />
            Cancelado
          </span>
          {/* <UncontrolledTooltip target={`agendamento-eye-${objectToFormattedString(row._id)}`}>
            {formattedCanceladoBy(row)}
          </UncontrolledTooltip>
          <i id={`agendamento-eye-${objectToFormattedString(row._id)}`} className="ml-2 fa-solid fa-eye text-primary" /> */}
        </span>
      );
    }

    if (row?.fatura === 'aberto') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          {/* <UncontrolledTooltip target={`status-${objectToFormattedString(row._id)}`}>
            Clique para Fechar.
          </UncontrolledTooltip> */}
          <span id={`status-${objectToFormattedString(row._id)}`}>
            <i className="fa-solid fa-circle text-success mr-2" />
            Em Aberto
          </span>
          {/* <i className="ml-2 fa-solid fa-pen text-primary" /> */}
        </span>
      );
    }

    if (row?.fatura === 'fechado') {
      if (row?.atendimentoStatus === 'cancelado') {
        return (
          <span className="d-flex w-100 justify-content-between align-items-center">
            <span id={`status-${objectToFormattedString(row._id)}`}>
              <i className="fa-solid fa-circle text-warning mr-2" />
              Fechado
            </span>
            {/* <i className="ml-2 fa-solid fa-pen text-transparent" /> */}
          </span>
        );
      }
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          {/* <UncontrolledTooltip target={`status-${objectToFormattedString(row._id)}`}>
            Clique para Alterar.
          </UncontrolledTooltip> */}
          <span id={`status-${objectToFormattedString(row._id)}`}>
            <i className="fa-solid fa-circle text-warning mr-2" />
            Fechado
          </span>
          {/* <i className="ml-2 fa-solid fa-pen text-primary" /> */}
        </span>
      );
    }

    if (row?.fatura === 'emitido') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          {/* <UncontrolledTooltip target={`status-${objectToFormattedString(row._id)}`}>
            Clique para Reabrir.
          </UncontrolledTooltip> */}
          <span id={`status-${objectToFormattedString(row._id)}`}>
            <i className="fa-solid fa-circle text-danger mr-2" />
            Emitido
          </span>
          {/* <i className="ml-2 fa-solid fa-pen text-primary" /> */}
        </span>
      );
    }

    return (
      <>
        <UncontrolledTooltip target={`status-${objectToFormattedString(row._id)}`}>
          Não Identificado
        </UncontrolledTooltip>
        <i
          id={`status-${objectToFormattedString(row._id)}`}
          className="fa-solid fa-circle-question text-danger mt-2"
        />
      </>
    );
  }, []);

  /* const folhaPagamentoHumanReadableFormatter = useCallback((row) => {
    if (row?.contaDe === 'fornecedor') {
      return (
        <>
          <i className="fa-solid fa-building-user text-success mr-2" />
          Não Emite
        </>
      );
    }

    if (!row?.folhaPagamentoHumanReadable) {
      return (
        <>
          <i className="fa-solid fa-spinner text-warning mr-2" />
          Não Gerado
        </>
      );
    }

    return (
      <>
        <i className="fa-solid fa-hashtag text-danger mr-2" />
        {row?.folhaPagamentoHumanReadable}
      </>
    );
  }, []); */

  const situacaoFormatter = useCallback((row) => {
    if (row?.atendimentoStatus === 'cancelado') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          {/* <UncontrolledTooltip target={`agendamento-${objectToFormattedString(row._id)}`}>
            {formattedCanceladoBy(row)}
          </UncontrolledTooltip> */}
          <span id={`agendamento-${objectToFormattedString(row._id)}`}>
            <i className="fa-solid fa-calendar-xmark text-danger mr-2" />
            Cancelado
          </span>
          {/* <UncontrolledTooltip target={`agendamento-eye-${objectToFormattedString(row._id)}`}>
            {formattedCanceladoBy(row)}
          </UncontrolledTooltip>
          <i id={`agendamento-eye-${objectToFormattedString(row._id)}`} className="ml-2 fa-solid fa-eye text-primary" /> */}
        </span>
      );
    }

    if (row?.situacao === 'a-vencer') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          {/* <UncontrolledTooltip target={`situacao-${objectToFormattedString(row._id)}`}>
            Clique para Pagar.
          </UncontrolledTooltip> */}
          <span id={`situacao-${objectToFormattedString(row._id)}`}>
            <i className="fa-solid fa-circle-info text-info mr-2" />
            A Vencer
          </span>
          {/* <i className="ml-2 fa-solid fa-pen text-primary" /> */}
        </span>
      );
    }

    if (row?.situacao === 'pago') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <span id={`situacao-${objectToFormattedString(row._id)}`}>
            <i className="fa-solid fa-circle-check text-success mr-2" />
            Pago
          </span>
          {/* <i className="ml-2 fa-solid fa-pen text-transparent" /> */}
        </span>
      );
    }

    if (row?.situacao === 'vencido') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          {/* <UncontrolledTooltip target={`situacao-${objectToFormattedString(row._id)}`}>
            Clique para Pagar.
          </UncontrolledTooltip> */}
          <span id={`situacao-${objectToFormattedString(row._id)}`}>
            <i className="fa-solid fa-circle-xmark text-danger mr-2" />
            Vencido
          </span>
          {/* <i className="ml-2 fa-solid fa-pen text-primary" /> */}
        </span>
      );
    }

    return (
      <>
        <UncontrolledTooltip target={`situacao-${objectToFormattedString(row._id)}`}>
          Não Identificado
        </UncontrolledTooltip>
        <i
          id={`situacao-${objectToFormattedString(row._id)}`}
          className="fa-solid fa-circle-question text-danger mt-2"
        />
      </>
    );
  }, []);

  const nameFormatter = useCallback((row) => {
    if (row?.profissionalNome) {
      return (
        <div className="d-flex align-items-center">
          <UncontrolledTooltip target={`nome-tipo-${objectToFormattedString(row._id)}`}>
            Profissional
          </UncontrolledTooltip>
          <i
            id={`nome-tipo-${objectToFormattedString(row._id)}`}
            className="fa-solid fa-user text-success mr-2"
          />
          {row.profissionalNome}
        </div>
      );
    }

    return (
      <>
        <UncontrolledTooltip target={`nome-tipo-${objectToFormattedString(row._id)}`}>
          Não Identificado
        </UncontrolledTooltip>
        <i
          id={`nome-tipo-${objectToFormattedString(row._id)}`}
          className="fa-solid fa-circle-question text-danger mt-2"
        />
      </>
    );
  }, []);

  const grupoFormatter = useCallback((row) => {
    if (row?.grupoNome) {
      return (
        <div className="d-flex align-items-center">
          <UncontrolledTooltip target={`nome-tipo-${objectToFormattedString(row._id)}`}>
            Profissional
          </UncontrolledTooltip>
          <i
            id={`nome-tipo-${objectToFormattedString(row._id)}`}
            className="fa-solid fa-user text-success mr-2"
          />
          {row.grupoNome}
        </div>
      );
    }

    return (
      <>
        <UncontrolledTooltip target={`nome-tipo-${objectToFormattedString(row._id)}`}>
          Não Identificado
        </UncontrolledTooltip>
        <i
          id={`nome-tipo-${objectToFormattedString(row._id)}`}
          className="fa-solid fa-circle-question text-danger mt-2"
        />
      </>
    );
  }, []);

  const dataFechamentoFormatter = useCallback((row) => {
    if (typeof row.datafechamento === 'string') {
      return format(parseISO(row.datafechamento), 'dd/MM/yyyy');
    }

    if (typeof row.datafechamento === 'object' && row?.datafechamento?.dia) {
      return format(new Date(row.datafechamento.ano, row.datafechamento.mes - 1, row.datafechamento.dia), 'dd/MM/yyyy');
    }

    if (row.datafechamento) {
      return row.datafechamento;
    }

    return 'Sem Fechamento';
  }, []);

  const dataVencimentoFormatter = useCallback((row) => {
    if (typeof row.dataVencimento === 'string') {
      return format(parseISO(row.dataVencimento), 'dd/MM/yyyy');
    }

    if (typeof row.dataVencimento === 'object' && row?.dataVencimento?.dia) {
      return format(new Date(row.dataVencimento.ano, row.dataVencimento.mes - 1, row.dataVencimento.dia), 'dd/MM/yyyy');
    }

    if (row.dataVencimento) {
      return row.dataVencimento;
    }

    return 'Sem Vencimento';
  }, []);

  const dataEmissaoFormatter = useCallback((row) => {
    if (typeof row.dataEmissao === 'string') {
      return format(parseISO(row.dataEmissao), 'dd/MM/yyyy HH:mm');
    }

    if (typeof row.dataEmissao === 'object' && row?.dataEmissao?.dia) {
      return format(new Date(row.dataEmissao.ano, row.dataEmissao.mes - 1, row.dataEmissao.dia), 'dd/MM/yyyy');
    }

    if (row.dataEmissao) {
      return row.dataEmissao;
    }

    return 'Sem Emissão';
  }, []);

  const dataPagamentoFormatter = useCallback((row) => {
    if (typeof row.dataPagamento === 'string') {
      return format(parseISO(row.dataPagamento), 'dd/MM/yyyy HH:mm');
    }

    if (typeof row.dataPagamento === 'object' && row?.dataPagamento?.dia) {
      return format(new Date(row.dataPagamento.ano, row.dataPagamento.mes - 1, row.dataPagamento.dia), 'dd/MM/yyyy');
    }

    if (row.dataPagamento) {
      return row.dataPagamento;
    }

    return 'Sem Pagamento';
  }, []);

  const mesFilter = useMemo(
    () => {
      const currentYear = new Date().getFullYear();
      const nextYear = currentYear + 1;
      const previousYear = currentYear - 1;

      const filters = [];

      // Adiciona meses do ano anterior
      months.forEach((month) => {
        filters.push({
          value: `${month.value}-${previousYear}`,
          label: `${month.label}/${previousYear}`,
        });
      });

      // Adiciona meses do ano atual
      months.forEach((month) => {
        filters.push({
          value: `${month.value}-${currentYear}`,
          label: `${month.label}/${currentYear}`,
        });
      });

      // Adiciona meses do próximo ano
      months.forEach((month) => {
        filters.push({
          value: `${month.value}-${nextYear}`,
          label: `${month.label}/${nextYear}`,
        });
      });

      return filters;
    },
    [],
  );

  // const tipoLancamentoFilter = useMemo(
  //   () => [
  //     /* {
  //       value: 'LANÇAMENTO ADMINISTRATIVO',
  //       label: 'LANÇAMENTO ADMINISTRATIVO',
  //     }, */
  //     {
  //       value: 'NOTA FISCAL',
  //       label: 'NOTA FISCAL',
  //     },
  //   ],
  //   [],
  // );

  const statusFilter = useMemo(
    () => [
      {
        value: 'aberto',
        label: 'Em aberto',
      },
      {
        value: 'fechado',
        label: 'Fechado',
      },
      {
        value: 'emitido',
        label: 'Emitido',
      },
    ],
    [],
  );

  const situacaoFilter = useMemo(
    () => [
      {
        value: 'a-vencer',
        label: 'A Vencer',
      },
      {
        value: 'pago',
        label: 'Pago',
      },
      {
        value: 'vencido',
        label: 'Vencido',
      },
    ],
    [],
  );

  const columns = useMemo(
    () => [
      {
        dataField: 'tipo',
        text: 'Módulo',
        // selectFilter: tipoFilter,
        formatter: tipoFormatter,
        className: 'text-center',
        width: '50px',
      },
      {
        dataField: 'grupo',
        text: 'Grupo',
        textFilter: true,
        formatter: grupoFormatter,
        width: '100%',
      },
      {
        dataField: 'name',
        text: 'Profissional',
        textFilter: true,
        formatter: nameFormatter,
        width: '100%',
      },
      {
        dataField: 'mesAtendimento',
        text: 'Mês/Ano',
        selectFilter: mesFilter,
        initValue: getMonth(new Date()) === 0 ? `${months.find((month) => month.value === getMonth(new Date()))?.value}-${getYear(new Date())}` : `${months.find((month) => month.value === 12)?.value}-${getYear(subYears(new Date(), 1), 1)}`,
        formatter: (row) => (row.mes && row.ano ? `${months.find((month) => month.value === parseInt(row.mes, 10))?.label}/${row.ano}` : '-'),
        // dateFilter: true,
        className: 'text-center',
        width: '120px',
      },
      /* {
        dataField: 'tipoLancamento',
        text: 'Tipo',
        selectFilter: tipoLancamentoFilter,
        className: 'text-center',
      }, */
      {
        dataField: 'empresaPagante',
        text: 'Empresa Pagante',
        textFilter: true,
        formatter: (row) => (row.razaoSocial ? `${row.razaoSocial}` : '-'),
        width: '100px',
      },
      {
        dataField: 'sub-total',
        text: 'Sub-Total',
        formatter: (row) => `${numberToCurrency(row?.total || 0)}`,
        width: '100px',
        dataType: 'money',
      },
      {
        dataField: 'reembolso',
        text: 'Reembolsos',
        formatter: (row) => `${numberToCurrency(row?.totalReembolso || 0)}`,
        width: '100px',
        dataType: 'money',
      },
      {
        dataField: 'outros-debitos-creditos',
        text: 'Débitos e Créditos',
        formatter: (row) => `${numberToCurrency(row?.totalOutrosDebitosCreditos || 0)}`,
        width: '100px',
        dataType: 'money',
      },
      {
        dataField: 'total',
        text: 'Total Mês',
        formatter: (row) => `${numberToCurrency((row?.total || 0) + (row?.totalReembolso || 0) + (row?.totalOutrosDebitosCreditos || 0))} (${row?.qty})`,
        width: '170px',
        dataType: 'money',
      },
      {
        dataField: 'nomeTitularConta',
        text: 'Titular da Conta',
        formatter: (row) => row?.nomeTitularConta || '-',
        width: '100%',
      },
      {
        dataField: 'nomeBanco',
        text: 'Banco',
        formatter: (row) => row?.nomeBanco || '-',
        width: '100%',
      },
      {
        dataField: 'numeroBanco',
        text: 'Nº Banco',
        formatter: (row) => row?.numeroBanco || '-',
        width: '100%',
      },
      {
        dataField: 'numeroAgencia',
        text: 'Nº Agência',
        formatter: (row) => row?.numeroAgencia || '-',
        width: '100%',
      },
      {
        dataField: 'tipoConta',
        text: 'Tipo de Conta',
        formatter: (row) => row?.tipoConta || '-',
        width: '100%',
      },
      {
        dataField: 'numeroConta',
        text: 'Nº Conta',
        formatter: (row) => row?.numeroConta || '-',
        width: '100%',
      },
      {
        dataField: 'digitoConta',
        text: 'Dígito Conta',
        formatter: (row) => row?.digitoConta || '-',
        width: '100%',
      },
      {
        dataField: 'formaPagamento',
        text: 'Forma de Pagamento',
        formatter: (row) => row?.formaPagamento || '-',
        width: '100%',
      },
      {
        dataField: 'chavePix',
        text: 'Chave Pix',
        formatter: (row) => row?.chavePix || '-',
        width: '100%',
      },
      {
        dataField: 'status',
        text: 'Fatura',
        selectFilter: statusFilter,
        formatter: statusFormatter,
        className: 'text-center',
        // onClick: (row, searchArray, page = 1, limit = 10) => handleChangeStatus(row, searchArray, page, limit),
      },
      /* {
        dataField: 'folhaPagamentoHumanReadable',
        text: 'Nº Fatura',
        textFilter: true,
        formatter: folhaPagamentoHumanReadableFormatter,
      }, */
      {
        dataField: 'situacao',
        text: 'Situação',
        selectFilter: situacaoFilter,
        formatter: situacaoFormatter,
        className: 'text-center',
        // onClick: (row, searchArray, page = 1, limit = 10) => handleChangeSituacao(row, searchArray, page, limit),
      },
      {
        dataField: 'dataFechamento',
        text: 'Fechamento',
        dateFilter: true,
        formatter: dataFechamentoFormatter,
        width: '100px',
        // editable: (row) => row.status === 'aberto',
        dataType: 'date',
      },
      {
        dataField: 'dataVencimento',
        text: 'Vencimento',
        dateFilter: true,
        formatter: dataVencimentoFormatter,
        width: '100px',
        // editable: (row) => row.status === 'aberto',
        dataType: 'date',
      },
      {
        dataField: 'dataEmissao',
        text: 'Emissão',
        dateFilter: true,
        formatter: dataEmissaoFormatter,
        width: '100px',
      },
      {
        dataField: 'dataPagamento',
        text: 'Pgto.',
        dateFilter: true,
        formatter: dataPagamentoFormatter,
        width: '100px',
      },
      {
        dataField: 'observacoesInternas',
        text: 'Observações Internas',
        width: '100%',
      },
    ],
    [],
  );

  const initialSelectedColumns = useMemo(() => {
    let saved;
    try {
      saved = JSON.parse(localStorage.getItem(COLUMNS_STORAGE_KEY_CONTAS_PAGAR));
    } catch {
      saved = null;
    }
    const dataFields = Array.isArray(saved) && saved.length > 0 ? saved : null;
    if (dataFields) {
      return columns.filter((c) => dataFields.includes(c.dataField));
    }
    return columns.filter((c) => !DEFAULT_HIDDEN_COLUMNS_CONTAS_PAGAR.includes(c.dataField));
  }, [columns]);

  useEffect(() => {
    setSelectedColumnsDataFields(initialSelectedColumns.map((column) => column.dataField));
  }, [initialSelectedColumns]);

  const handleColumnsChange = useCallback((cols) => {
    const dataFields = cols.map((c) => c.dataField);
    setSelectedColumnsDataFields((prev) => {
      if (prev.length === dataFields.length && prev.every((field, index) => field === dataFields[index])) {
        return prev;
      }
      return dataFields;
    });
    localStorage.setItem(COLUMNS_STORAGE_KEY_CONTAS_PAGAR, JSON.stringify(dataFields));
  }, []);

  return (
    <Container fluid>
      <AlertModal ref={alertRef} />
      <FinanceiroEdit ref={modalFinanceiroEdit} />
      <CustomModal ref={modal} />
      {/* <CustomModalEmitirFatura ref={modalEmitirFatura} /> */}
      <CustomModalFecharFatura ref={modalFecharFatura} />
      <CustomModalFecharFaturas ref={modalFecharFaturas} />
      <CustomModalPagarFaturas ref={modalPagarFaturas} />
      <CustomModalPagarFatura ref={modalPagarFatura} />
      <CustomModalMotivoCancelamento ref={modalMotivoCancelamento} />
      <ModalContaPagarTableInfo ref={modalContaPagarTableInfo} />
      <Row className="mt-5">
        <Col>
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <h3>Contas a Pagar</h3>
                </Col>
              </Row>
            </CardBody>
            <CardFooter>
              <Row>
                <Col xs={12} md={6} lg={4}>
                  <Card color="danger">
                    <CardHeader tag="h4" className="text-white text-truncate">
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Contas a Pagar</span>
                        <UncontrolledTooltip target="gerar-contas-a-pagar-relatorio-csv">
                          Gerar Relatório CSV com todas as contas a pagar contabilizadas nesse total
                        </UncontrolledTooltip>
                        <Button id="gerar-contas-a-pagar-relatorio-csv" color="link" className="text-white text-decoration-none" onClick={handleGerarRelatorioContasPagar}>
                          <i className="fa-solid fa-file-csv mr-2" />
                        </Button>
                      </div>
                    </CardHeader>
                    <CardBody className="bg-pink">
                      <div className="d-flex flex-wrap align-items-center">
                        <i className="fa-solid fa-money-bill-transfer text-white mr-3" style={{ fontSize: '1.75rem' }} />
                        <Fade>
                          <span className="text-white" style={{ fontSize: '2.25rem' }}>{numberToCurrency(totalContaPagar)}</span>
                        </Fade>
                      </div>
                    </CardBody>
                    {/* <CardFooter>
                      <Button color="link" className="text-white text-decoration-none" onClick={() => navigate('/conta-pagar')} block>
                        Criar Conta a Pagar
                      </Button>
                    </CardFooter> */}
                  </Card>
                </Col>
                <Col xs={12} md={6} lg={4}>
                  <Card color="success">
                    <CardHeader tag="h4" className="text-white text-truncate">
                      Contas a Receber
                    </CardHeader>
                    <CardBody>
                      <div className="d-flex flex-wrap align-items-center">
                        <i className="fa-solid fa-hand-holding-dollar text-white mr-3" style={{ fontSize: '1.75rem' }} />
                        <Fade>
                          <span className="text-white" style={{ fontSize: '2.25rem' }}>{numberToCurrency(totalContaReceber)}</span>
                        </Fade>
                      </div>
                    </CardBody>
                    {/* <CardFooter>
                      <Button color="link" className="text-white text-decoration-none" onClick={() => navigate('/conta-receber')} block>
                        Criar Conta a Receber
                      </Button>
                    </CardFooter> */}
                  </Card>
                </Col>
                <Col xs={12} md={12} lg={4}>
                  <Card color="info">
                    <CardHeader tag="h4" className="text-white text-truncate">
                      Saldo
                    </CardHeader>
                    <CardBody>
                      <div className="d-flex flex-wrap align-items-center">
                        <i className={classNames('fa-solid fa-sack-dollar mr-3', { 'text-white': (totalContaReceber - totalContaPagar >= 0), 'text-danger': (totalContaReceber - totalContaPagar < 0) })} style={{ fontSize: '1.75rem' }} />
                        <Fade>
                          <span className={classNames({ 'text-white': (totalContaReceber - totalContaPagar >= 0), 'text-danger': (totalContaReceber - totalContaPagar < 0) })} style={{ fontSize: '2.25rem' }}>{numberToCurrency(totalContaReceber - totalContaPagar)}</span>
                        </Fade>
                      </div>
                    </CardBody>
                    {/* <CardFooter>
                      <Button color="link" className="text-white text-decoration-none" style={{ cursor: 'default' }} onClick={() => null} block>
                        Saldo
                      </Button>
                    </CardFooter> */}
                  </Card>
                </Col>
              </Row>
            </CardFooter>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col tag="div" className="d-flex flex-column" style={{ paddingLeft: '2.25rem', width: '100%', maxWidth: '600px' }}>
          {/* <Fade>
            <Button
              color="danger"
              className="mr-2 mb-2"
              onClick={() => setShowCloseFinanceiroModal(true)}
            >
              Fechar Financeiro por Período
            </Button>
          </Fade> */}
          {/* {selectedRows.filter((selectedRow) => (selectedRow.status === 'aberto')).length ? (
            <Fade>
              <Button color="danger" className="mr-2 mb-2" onClick={handleFecharFaturaSelecionadas}>
                {`Fechar ${selectedRows.filter((selectedRow) => selectedRow.status === 'aberto').length} Fatura(s)`}
              </Button>
            </Fade>
          ) : null} */}
          {selectedRows.length ? (
            <Button
              color="info"
              className={classNames('mr-2 mb-2')}
              onClick={handleFecharFaturaSelecionadas}
            >
              {/* {`Fechar Financeiro - ${selectedRows.filter((selectedRow) => (selectedRow.status === 'aberto')).length} financeiro(s) aberto(s)`} */}
              Fechar Financeiro em Lote
            </Button>
          ) : null}
          {/* {selectedRows.some((selectedRow) => (selectedRow.fatura === 'fechado')) && (
            <Button
              color="warning"
              className={classNames('mr-2 mb-2')}
              onClick={handleGerarFolhaPagamento}
              >
              Gerar Folha de Pagamento em Lote
            </Button>
          )} */}
          {selectedRows.length ? (
            <Button color="success" className={classNames('mr-2 mb-2')} onClick={handlePagarFaturaSelecionadas}>
              {/* {`Pagar ${selectedRows.filter((selectedRow) => (selectedRow.situacao !== 'pago')).length} fatura(s)`} */}
              Pagar Faturas em Lote
            </Button>
          ) : null}
          <Button
            color="primary"
            className={classNames('mr-2 mb-2')}
            onClick={startFinancialDataUpdate}
            disabled={isUpdating}
          >
            <i className="fa-solid fa-sync-alt mr-2" />
            {isUpdating ? 'Atualizando...' : 'Atualizar Dados Financeiros'}
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <TableManager
            initialColumns={columns}
            initialSelectedColumns={initialSelectedColumns}
            onUpdate={(row) => handleToggleModalContaPagarTableInfo(row)}
            // onDelete={(row) => destroy(row._id, '/financeiros')}
            // onCreatePdf={handleCreatePdf}
            // onCreateCsv={handleCreateCsv}
            onSelectedRows={(rows) => {
              console.log(rows);
              setSelectedRows(rows);
            }}
            onClickRow={(row) => handleToggleModalContaPagarTableInfo(row)}
            onColumnsChange={handleColumnsChange}
            // showTotalFinance
            selectable
            selectableColumns
            enableDeletedItemsButton={false}
            enableDeletedItemButton={false}
            onSearchArray={(_searchArray) => setSearchArray(_searchArray)}
          />
        </Col>
      </Row>
      <Modal
        isOpen={showCloseFinanceiroModal}
        toggle={() => setShowCloseFinanceiroModal(!showCloseFinanceiroModal)}
        centered
      >
        <ModalHeader>
          <strong>Fechar Financeiro por período</strong>
          <Button
            className="close position-absolute top-4 right-4 py-1 px-2"
            onClick={() => setShowCloseFinanceiroModal(false)}
          >
            <i className="fas fa-times" />
          </Button>
        </ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col xs={6}>
                <DatePickerMaskedInput
                  label="Data de"
                  placeholderText="Data de"
                  selected={dataCloseFinanceiroInicio}
                  invalidMessage={validationErrors.dataCloseFinanceiroInicio}
                  onChange={(date) => setDataCloseFinanceiroInicio(date)}
                />
              </Col>
              <Col xs={6}>
                <DatePickerMaskedInput
                  label="Data até"
                  placeholderText="Data até"
                  selected={dataCloseFinanceiroTermino}
                  invalidMessage={validationErrors.dataCloseFinanceiroTermino}
                  onChange={(date) => setDataCloseFinanceiroTermino(date)}
                />
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={handleCloseFinanceiro}>Fechar Financeiro nesse período</Button>
        </ModalFooter>
      </Modal>

      {/* Modal de Atualização dos Dados Financeiros */}
      <Modal
        isOpen={showUpdateModal}
        toggle={closeUpdateModal}
        centered
        size="lg"
      >
        <ModalHeader>
          <strong>Atualização dos Dados Financeiros</strong>
          <Button
            className="close position-absolute top-4 right-4 py-1 px-2"
            onClick={closeUpdateModal}
          >
            <i className="fas fa-times" />
          </Button>
        </ModalHeader>
        <ModalBody>
          {isUpdating && !updateStatus ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Carregando...</span>
              </div>
              <p className="mt-3 mb-0">Iniciando atualização dos dados financeiros...</p>
            </div>
          ) : updateStatus ? (
            <div>
              <Row className="mb-3">
                <Col>
                  <div className="d-flex align-items-center">
                    <i className={`fa-solid fa-circle mr-2 ${updateStatus.data.isUpdating ? 'text-warning' : 'text-success'}`} />
                    <strong>
                      {updateStatus.data.isUpdating ? 'Atualização em andamento...' : 'Atualização concluída!'}
                    </strong>
                  </div>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col>
                  <Button
                    color="link"
                    className="p-0 text-decoration-none"
                    onClick={() => setShowUpdateDetails(!showUpdateDetails)}
                  >
                    <i className={`fa-solid fa-chevron-${showUpdateDetails ? 'up' : 'down'} mr-2`} />
                    Ver informações detalhadas da atualização
                  </Button>
                </Col>
              </Row>

              <Collapse isOpen={showUpdateDetails}>
                <Row className="mb-3">
                  <Col xs={6}>
                    <Card color="success" className="text-center">
                      <CardBody>
                        <h5 className="text-white">{updateStatus.data.viewCount}</h5>
                        <small className="text-white">Registros Atualizados</small>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xs={6}>
                    <Card color="dark" className="text-center">
                      <CardBody>
                        <h5 className="text-white">{updateStatus.data.originalCount}</h5>
                        <small className="text-white">Registros Originais</small>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col xs={6}>
                    <Card color={updateStatus.data.difference === 0 ? 'info' : 'warning'} className="text-center">
                      <CardBody>
                        <h5 className="text-white">{updateStatus.data.difference}</h5>
                        <small className="text-white">Diferença</small>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xs={6}>
                    <Card color="primary" className="text-center">
                      <CardBody>
                        <h6 className="text-white">
                          {updateStatus.data.lastUpdated
                            ? format(parseISO(updateStatus.data.lastUpdated), 'dd/MM/yyyy HH:mm:ss')
                            : 'N/A'}
                        </h6>
                        <small className="text-white">Última Atualização</small>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>

                {/* {updateStatus.data.oldestDocument && (
                  <Row>
                    <Col>
                      <Card color="light">
                        <CardBody className="text-center">
                          <h6 className="mb-1">Documento Mais Antigo</h6>
                          <small className="text-muted">
                            {format(parseISO(updateStatus.data.oldestDocument), 'dd/MM/yyyy HH:mm:ss')}
                          </small>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                )} */}
              </Collapse>

              {updateStatus.data.isUpdating && (
                <Row className="mt-3">
                  <Col>
                    <div className="progress">
                      <div
                        className="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        style={{ width: '100%' }}
                      >
                        Processando...
                      </div>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={closeUpdateModal}
            disabled={isUpdating}
          >
            {isUpdating ? 'Atualizando...' : 'Fechar'}
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
}

export default ContasPagarAgrupado;
